module.exports = __webpack_public_path__ + "static/media/icon.ef0ed397.less";